export default __webpack_public_path__ + "static/media/dot.22162765.svg";